import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const component = document.querySelector( '.info-left-right' );
      if ( component ) {
        const lines = component.querySelectorAll( '.info-left-right__draw' );
        const circles = component.querySelectorAll( '.info-left-right__circle' );

        gsap.set( lines, {
          scaleX: 0,
          transformOrigin: '100% 50%',
        } );

        gsap.set( circles, {
          scale: 0,
          transformOrigin: 'center center',
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        } );

        lines.forEach( ( line, i ) => {
          tl.to( line, {
            scaleX: 1,
            duration: 1,
            ease: 'power2.out',
          }, i * 0.6 )
              .to( circles[i], {
                scale: 1,
                duration: 0.3,
                ease: 'back.out(1.7)',
              }, i * 0.6 + 1 );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'info-left-right', COMPONENT );
} )( app );
